export const AUDITORY_MODEL = {
  paso: 2,
  pasoDescripcion: "PASO_DIRECCION",
};

export const DATA_MODEL = {
  title: "Completa tus datos",
  nextStep: "/comprar/seguro-vida-endoso-con-devolucion/pago",
  errorStep: "/comprar/seguro-vida-endoso-con-devolucion/error",
  disclaimerText: `Puedes modificar a tus beneficiarios en cualquier momento enviando un correo a <a href="mailto:atencionalcliente@rimac.com.pe">atencionalcliente@rimac.com.pe</a>`,
};

export const RIGHT_OF_WITHDRAWAL_MODEL = {
  title: "¿Qué es lo que no cubrimos?",
  items: [
    "Situación o enfermedad preexistente, diagnosticadas por un profesional médico, conocidas por el asegurado y no mencionadas en la solicitud del seguro.",
    "Si el asegurado se desempeña en oficios peligrosos, el fallecimiento no estará cubierto al originarse durante o a consecuencia de dichas actividades, como miembro de fuerzas armadas y policiales, personal de seguridad, salvavidas, entre otros.",
    "Cuando el asegurado participa en actos delictivos, subversivos o terroristas que vayan en contra del orden público dentro o fuera del país.",
    "Accidente provocado por cualquier persona involucrada en el contrato, sea heredero o beneficiario, con el fin de recibir la suma asegurada.",
    "Cuando el asegurado se encuentra en estado de ebriedad o bajo el efecto de drogas y esta situación sea acto generador de un acontecimiento desafortunado.",
    "En caso ocurra un suicidio o autolesión en los dos primeros años en que se contrató el seguro.",
  ],
  tooltip:
    "Si estás realizándote un tratamiento médico comunícate al <b>(01) 411-6001</b> para declarar tu estado de salud y brindarte un producto pensado en ti.",
};
